import { useEffect, useState } from 'react';
import SignUpHeader from './Header';
import { ISignUpComponents } from 'types/signup';
import CustomInput from 'components/common/CustomInput';
import axios from 'axios';
import { toast } from 'react-toastify';
import Timer from 'components/common/Timer';
import { correctEmail, correctPw } from 'components/common/regex';
import { ReactComponent as EyeOn } from 'assets/common/eyeOn.svg'
import { ReactComponent as EyeOff } from 'assets/common/eyeOff.svg'
import AuthButton from 'components/common/AuthButton';
import { decryptAES, encryptAES } from 'components/encryptDecrpt';

const Second = ({ signUpInfo, setSignUpInfo, setClear }: ISignUpComponents) => {
    const [timeKey, setTimeKey] = useState<number>(0);
    const [isTimeOut, setIsTimeOut] = useState<boolean>(false)
    const [authCode, setAuthCode] = useState<string>('');
    const [serverAuthCode, setServerAuthCode] = useState<string>('');
    const [emailCheck, setEmailCheck] = useState<boolean>(false);
    const [pwShow1, setPwShow1] = useState<boolean>(false);
    const [pwShow2, setPwShow2] = useState<boolean>(false);
    const [pwErrors, setPwErrors] = useState({ pw1: false, pw2: false });
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        if (authCode.length > 5 && serverAuthCode) {
            toast[encryptAES(authCode) === serverAuthCode ? 'success' : 'error'](
                encryptAES(authCode) === serverAuthCode ? '정상적으로 인증되었습니다.' : '인증번호가 일치하지않습니다.'
            );
            setSignUpInfo(prev => ({ ...prev, emailChk: encryptAES(authCode) === serverAuthCode }));
        }
    }, [authCode, serverAuthCode]);

    useEffect(() => {
        setSignUpInfo(prev => ({
            ...prev,
            passwordChk: !pwErrors.pw1 && !pwErrors.pw2 && prev.password === prev.password2 && prev.password !== undefined && prev.password !== '',
        }));
    }, [pwErrors, signUpInfo.password, signUpInfo.password2]);

    useEffect(() => {
        setClear(false);
    }, []);

    useEffect(() => {
        setClear(signUpInfo.emailChk && signUpInfo.passwordChk);
    }, [signUpInfo]);

    useEffect(() => {
        setTimeKey(0)
        setIsTimeOut(false)
        setAuthCode('')
        setServerAuthCode('')
    }, [signUpInfo.username]);

    const sendEmail = (reSend?: boolean) => {
        if (!signUpInfo.username) return toast.error('이메일을 입력해주세요.')
        setLoading(true)
        const reqData = {
            email: signUpInfo.username,
            status: 'signUp',
        }
        postVerifyEmail(reqData).then(res => {
            // console.log(res.data)
            if (res.data.code === 200) {
                toast.success('인증번호를 발송했습니다.')
                setServerAuthCode(res.data.data)
                // console.log('키 >>>', decryptAES(res.data.data))
                !reSend && setTimeKey(1)
            }
            else if (res.data.code === 400) {
                toast.error('이미 가입된 이메일입니다.')
            }
        }).finally(() => {
            setLoading(false)
        })
    }

    const postVerifyEmail = async (reqData: object) => {
        const url = `${process.env.REACT_APP_API_URL2}verifyEmail`
        return await axios.post(url, reqData)
    }

    const reSendEmail = () => {
        setTimeKey(k => k + 1)
        setIsTimeOut(false)
        setAuthCode('')
        sendEmail(true);
    }

    const checkEmail = (email: string) => {
        setEmailCheck(!correctEmail(email))
    }

    const checkPw = (key: 'pw1' | 'pw2', pw: string) => {
        setPwErrors(prev => ({ ...prev, [key]: pw ? !correctPw(pw) : false }));
    };

    return (
        <>
            <SignUpHeader title={'가입정보 입력'} idx={2} />

            <div className='flex flex-col items-start gap-3 mb-6 mobile:mb-3'>
                <div className='flex justify-between items-center w-full'>
                    <p className='font-semibold mobile:text-base text-lg'>이메일<span className='text-red'> *</span></p>
                    {
                        emailCheck &&
                        <p className='text-red text-xs'>이메일 형식이 올바르지 않습니다.</p>
                    }
                </div>
                <div className='flex items-center gap-3 w-full'>
                    <CustomInput
                        className='flex-1'
                        type={'email'}
                        value={signUpInfo.username ?? ''}
                        name={''}
                        error={emailCheck}
                        disabled={signUpInfo.emailChk}
                        placeholder={'아이디로 사용할 이메일을 입력해주세요'}
                        onBlur={(e) => {
                            checkEmail(e.target.value)
                        }}
                        onChange={(e) => {
                            setSignUpInfo({
                                ...signUpInfo,
                                username: e.target.value
                            })
                        }}
                    />
                    {
                        !signUpInfo.emailChk &&
                        <>
                            {
                                timeKey === 0 ?
                                    <AuthButton
                                        loading={loading}
                                        title='인증번호'
                                        disabled={emailCheck}
                                        className={`${(!emailCheck && signUpInfo.username) ? 'text-primary border-primary' : 'text-[#9D9EB7] border-[#9D9EB7]'} mobile:h-10 mobile:text-sm mobile:w-[90px]`}
                                        onClick={sendEmail}
                                    /> :
                                    <AuthButton
                                        title='재요청'
                                        className='hover:bg-transparent border-red mobile:w-[90px] mobile:h-10 text-red hover:!text-red mobile:text-sm'
                                        onClick={reSendEmail}
                                    />
                            }
                        </>
                    }
                </div>
            </div>

            {
                !signUpInfo.emailChk &&
                <>
                    <div className='relative mobile:mb-6'>
                        {
                            timeKey > 0 &&
                            <div className='right-6 absolute flex items-center h-full'>
                                <Timer
                                    timerKey={timeKey}
                                    isTimeOut={isTimeOut}
                                    setIsTimeOut={setIsTimeOut}
                                />
                            </div>
                        }

                        <CustomInput
                            type={'text'}
                            value={authCode}
                            disabled={isTimeOut}
                            maxLength={6}
                            placeholder={'인증번호를 입력해주세요'}
                            onChange={(e) => {
                                setAuthCode(e.target.value)
                            }}
                        />
                    </div>
                    {/* 
                    {
                        serverAuthCode &&
                        <p>인증번호 :{serverAuthCode}</p>
                    } */}
                </>
            }

            {
                signUpInfo.emailChk &&
                <div className='flex flex-col items-start gap-3 mb-6'>
                    <div className='flex mobile:flex-col justify-between items-center mobile:items-start w-full'>
                        <p className='font-semibold mobile:text-base text-lg'>
                            비밀번호<span className='text-red'> *</span>
                        </p>
                        <p className='text-xs'>
                            비밀번호는 영문 대문자 숫자 특수문자를 포함한 8자리 이상이어야 합니다.
                        </p>
                    </div>

                    {[1, 2].map((num) => {
                        const isShow = num === 1 ? pwShow1 : pwShow2;
                        const setShow = num === 1 ? setPwShow1 : setPwShow2;
                        const pwKey = num === 1 ? 'password' : 'password2';
                        const pwChk = num === 1 ? pwErrors.pw1 : pwErrors.pw2;
                        const placeholder = num === 1 ? '비밀번호 입력' : '비밀번호 재확인';

                        return (
                            <div className='relative w-full' key={num}>
                                <CustomInput
                                    type={isShow ? 'text' : 'password'}
                                    value={signUpInfo[pwKey] ?? ''}
                                    name={pwKey}
                                    error={pwChk}
                                    placeholder={placeholder}
                                    onBlur={(e) => checkPw(num === 1 ? 'pw1' : 'pw2', e.target.value)}
                                    onChange={(e) =>
                                        setSignUpInfo({
                                            ...signUpInfo,
                                            [pwKey]: e.target.value,
                                        })
                                    }
                                />
                                <div
                                    className='top-0 right-6 absolute flex items-center h-full cursor-pointer'
                                    onClick={() => setShow((prev) => !prev)}
                                >
                                    {isShow ? <EyeOn /> : <EyeOff />}
                                </div>
                            </div>
                        );
                    })}
                </div>

            }
        </>
    )
}

export default Second